class TableSwitch extends HTMLElement {
  constructor() {
    super()

    this.tabs = [...this.querySelectorAll('.js-table-btn')]
    this.tabPanels = this.querySelectorAll('[data-size-guide-table]')

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.showTabPanel)
    })
  }

  showTabPanel = () => {
    const target = event.target
    const targetUnit = target.getAttribute('data-unit')

    // find panel to open through the aria-controls of the clicked tab button
    const tabPanelToOpen = this.querySelector(
      `[data-size-guide-table=${targetUnit}]`
    )

    this.tabPanels.forEach((tabPanel) => {
      tabPanel.style.display = 'none'
      tabPanel.removeAttribute('tabindex')
      tabPanel.setAttribute('aria-hidden', true)
    })

    this.tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', 'false')
      tab.classList.remove('active')
    })

    // open selected tab and set focus on content so user bypasses other tabs
    tabPanelToOpen.style.display = 'block'
    tabPanelToOpen.setAttribute('tabindex', -1)
    tabPanelToOpen.setAttribute('aria-hidden', false)
    // tabPanelToOpen.focus()

    // highlight open tab button and update aria
    target.setAttribute('aria-selected', 'true')
    target.classList.add('active')
  }
}

customElements.define('table-switch', TableSwitch)
